<div class="content">

  <div class="header">{{ 'bikeshop.rentals.configuration.custom_pickup_slots' | translate }}</div>


  <div class="row margin-top-16">
    <div class="col-md-6 label" [ngClass]="{invalid: !data.date}">{{
      'bikeshop.shop_profile.collections.override_date' | translate }}</div>
    <div class="col-md-6 flex">
      <div style="width: 100%">
        <p-calendar [(ngModel)]="data.date" [minDate]="minDate" [dateFormat]="countryData.DatePickerFormat">
        </p-calendar>
      </div>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-6 label">{{ 'bikeshop.rentals.configuration.is_open' | translate }}</div>
    <div class="col-md-6">
      <p-inputSwitch [(ngModel)]="data.isWorking"></p-inputSwitch>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-6 label" [ngClass]="{invalid: data.isWorking && !data.startTime}">{{
      'bikeshop.rentals.configuration.open_time' | translate }}</div>
    <div class="col-md-6 flex">
      <div style="width: 100%">
        <p-calendar [(ngModel)]="data.startTime" [readonlyInput]="true" [disabled]="!data.isWorking" (onFocus)="setDefaultStartTime()" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly">
        </p-calendar>
      </div>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-6 label" [ngClass]="{invalid: data.isWorking && (!data.endTime || data.endTime <= data.startTime)}">{{
      'bikeshop.rentals.configuration.close_time' | translate }}</div>
    <div class="col-md-6 flex">
      <div style="width: 100%">
        <p-calendar [(ngModel)]="data.endTime" [readonlyInput]="true" [disabled]="!data.isWorking" (onFocus)="setDefaultEndTime()" [timeOnly]="true" [hourFormat]="'12'" inputId="timeonly"></p-calendar>
      </div>
    </div>
  </div>

  <div class="margin-top-16">
    <div class="row">
      <div class="col-md-8 label"></div>
      <div class="col-md-4">
        <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
          label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
          [disabled]="saving || !valid()"></button>
      </div>
    </div>
  </div>
